import { useEffect, useState } from 'react';
import { usersApi, hasFullScope, type UserBrief, type ScopeInfo } from '../api/client.js';

/**
 * 8.4 数据可见范围条：
 * - admin/senior：「整体 / 我负责的 / 按负责人」圈定器（回答「报表能不能按客户/员工选」）
 * - accountant/viewer：不可切换，恒展示受限横幅（服务端已强制收窄，宁提示不误导）
 */
export default function ScopeBar({
  value,
  onChange,
  scopeInfo,
}: {
  value: string;
  onChange: (v: string) => void;
  scopeInfo?: ScopeInfo | null;
}) {
  const full = hasFullScope();
  const [users, setUsers] = useState<UserBrief[]>([]);

  useEffect(() => {
    if (!full) return;
    usersApi.list().then(setUsers).catch(() => { /* 成员接口失败时退化为无负责人选项 */ });
  }, [full]);

  const ownerUsers = users.filter((u) => u.isActive && u.role !== 'viewer');
  const ownerSelected = value.startsWith('owner:') ? value.slice(6) : '';

  if (!full) {
    return (
      <div className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800" data-testid="scope-banner">
        🔒 数据范围：仅显示<b>你负责的与未分配（公开）</b>往来单位相关的凭证、账龄与预警；如需查看整体数据请联系管理员。
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-2 text-sm">
      <span className="text-slate-500">数据范围</span>
      <select
        className="rounded-md border border-slate-300 bg-white px-2 py-1 text-sm"
        value={value.startsWith('owner:') ? 'owner' : value}
        onChange={(e) => {
          const v = e.target.value;
          onChange(v === 'owner' ? (ownerSelected ? `owner:${ownerSelected}` : (ownerUsers[0] ? `owner:${ownerUsers[0].id}` : 'all')) : v);
        }}
      >
        <option value="all">整体（全租户）</option>
        <option value="mine">我负责的</option>
        <option value="owner">按负责人…</option>
      </select>
      {value.startsWith('owner:') && (
        <select
          className="rounded-md border border-slate-300 bg-white px-2 py-1 text-sm"
          value={ownerSelected}
          onChange={(e) => onChange(e.target.value ? `owner:${e.target.value}` : 'all')}
        >
          <option value="">请选择成员</option>
          {ownerUsers.map((u) => (
            <option key={u.id} value={u.id}>{u.displayName}</option>
          ))}
        </select>
      )}
      {scopeInfo?.limited && (
        <span className="rounded-md border border-amber-200 bg-amber-50 px-2 py-1 text-amber-800">
          ⚠️ 请求范围超出权限，已按你的数据范围收窄
        </span>
      )}
    </div>
  );
}
